import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@chakra-ui/button';
import NextImage from 'next/image';
import { useTheme } from '@chakra-ui/react';
import { AspectRatio } from '@chakra-ui/react';
import { getBlurUrl } from '@outdoorly/util';
import { getImageLoader } from '@outdoorly/util';

const WrappedComponent = ({
  onClick,
  index,
  isActive,
  image,
  buttonRefsArray,
}) => {
  const theme = useTheme();
  return (
    <IconButton
      variant="outline"
      onClick={onClick}
      display="inline"
      padding={'0 !important'}
      w="72px"
      h="72px"
      mx={2}
      ref={buttonRefsArray[index]}
      _focus={{ outline: 0 }}
      border={0}
      backgroundColor="scheme.bgSecondary"
      borderRadius="lg"
      icon={
        <AspectRatio
          ratio={1}
          width="full"
          overflow="hidden"
          borderRadius={theme.radii.lg}
          background="scheme."
          sx={{
            '& > div > img': {
              border: isActive
                ? `2px solid ${theme.colors.scheme.controlActive} !important`
                : '2px solid white !important',
              outline: isActive
                ? `2px solid ${theme.colors.scheme.controlActive}`
                : 0,
              outlineOffset: isActive ? '-3px' : 0,
              WebkitUserDrag: 'none',
              KhtmlUserDrag: 'none',
              MozUserDrag: 'none',
              OUserDrag: 'none',
              borderRadius: theme.radii.lg,
              mixBlendMode: 'darken',
            },
          }}
        >
          <NextImage
            src={image?.url}
            layout="fill"
            placeholder="blur"
            objectFit="contain"
            blurDataURL={getBlurUrl(image?.url)}
            className="smooth-filter"
            alt={image?.alt}
            itemID={index}
            sizes="72px"
            loader={getImageLoader(image?.url)}
          />
        </AspectRatio>
      }
    />
  );
};
export const ProductThumbnailsForCarousel = React.memo(WrappedComponent);

WrappedComponent.propTypes = {
  buttonRefsArray: PropTypes.arrayOf(
    PropTypes.oneOf([PropTypes.string, PropTypes.func, null])
  ),
  image: PropTypes.shape({
    alt: PropTypes.string,
    url: PropTypes.string,
  }),
  index: PropTypes.number,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};
